import "./IndustryImageTextSection.scss";
import FAMILY_CASE_RIGHT_IMG from "../../../assets/img/FAMILY_CASE_RIGHT_IMG.png";
import FAMILY_CASE_LEFT_IMG from "../../../assets/img/FAMILY_CASE_LEFT_IMG.png";
import { useLanguageCtx } from "../../../store/providers/LanguageContext";
import content from "./content";

const IndustryImageTextSection = ({
	image,
	imgShadow,
	imgRadius,
	boldText,
	boldParagraph,
	yellowText,
	paragraphs,
	paragraphs_2,
	checkText,
	switchOrder,
	funciones,
	inBanner,
	familyCase,
	leftBoldText,
	lefText,
	rightBoldText,
	rightext,
	children,
	responsiveImgPosition
}) => {
	const {language} = useLanguageCtx();

	const imageSide = (
		<div
			className={`IndustryImageTextSection--image_side-container ${
				imgRadius && "img-radius"
			} ${responsiveImgPosition && responsiveImgPosition}`}
		>
			<img
				src={image ? image.img : ""}
				alt={image ? image.alt : ""}
				className={`all-width-height aspec-ratio container ${
					imgShadow && "img-shadow"
				} ${imgRadius && "img-radius"}`}
			/>
		</div>
	);

	const contentSide = (
		<div className="IndustryImageTextSection--content_side-container">
			{yellowText && (
				<h5 className="t5 c-yellow yellow-line right-side">{yellowText}</h5>
			)}
			<h4 className={`t4 ${(inBanner || funciones) && "c-white"}`}>
				{boldText}
			</h4>
			{boldParagraph && <p className="body-18 bold c-black">{boldParagraph}</p>}
			{paragraphs &&
				paragraphs.map((paragraph) => (
					<p
						className={`body-18 ${
							inBanner || funciones ? "c-white" : "c-black"
						}`}
					>
						{paragraph}
					</p>
				))}
			{checkText &&
				checkText.map((text, index) => (
					<p
						className={`IndustryImageTextSection--check_text text-width-check no-space body-16 ${
							inBanner || funciones ? "orange c-white" : "white c-black"
						}`}
						key={index}
					>
						{text}
					</p>
				))}
			{paragraphs_2 &&
				paragraphs_2.map((paragraph) => (
					<p
						className={`body-18 c-black ${
							(inBanner || funciones) && "c-white"
						}`}
					>
						{paragraph}
					</p>
				))}
			{children}
		</div>
	);

	const funcionesSide = (
		<div className="grid fullColumn all-height IndustryImageTextSection--funciones_side-container">
			<h5 className="t5 c-yellow industryImageTextSection-funciones-text combustible position-1">
				{content[language].function_1}
			</h5>
			<h5 className="t5 c-yellow industryImageTextSection-funciones-text temperatura position-2">
				{content[language].function_2}
			</h5>
			<h5 className="t5 c-yellow industryImageTextSection-funciones-text obd2 position-3">
				{content[language].function_3}
			</h5>
			<h5 className="t5 c-yellow industryImageTextSection-funciones-text cerraduras position-4">
				{content[language].function_4}
			</h5>
			<h5 className="t5 c-yellow industryImageTextSection-funciones-text canbus position-5">
				{content[language].function_5}
			</h5>
			<h5 className="t5 c-yellow industryImageTextSection-funciones-text voz position-6">
				{content[language].function_6}
			</h5>
			<h5 className="t5 c-yellow industryImageTextSection-funciones-text video position-7">
				{content[language].function_7}
			</h5>
		</div>
	);

	const familyJsx = (
		<>
			<div className="flex column center-cross-axis IndustryImageTextSection--familyJsx-container">
				<img src={FAMILY_CASE_LEFT_IMG} alt="Persona Conduciendo" />
				<h4 className="t4 c-white center-text">{leftBoldText}</h4>
				<p className="body-18 c-white center-text">{lefText}</p>
			</div>
			<div className="flex column center-cross-axis IndustryImageTextSection--familyJsx-container">
				<img src={FAMILY_CASE_RIGHT_IMG} alt="Persona Conduciendo" />
				<h4 className="t4 c-white center-text">{rightBoldText}</h4>
				<p className="body-18 c-white center-text">{rightext}</p>
			</div>
		</>
	);

	return (
		<div className="IndustryImageTextSection--container max-width">
			{!switchOrder && !funciones && !familyCase && (
				<>
					{imageSide}
					{contentSide}
				</>
			)}
			{switchOrder && (
				<>
					{contentSide}
					{funciones && funcionesSide}
					{!funciones && imageSide}
				</>
			)}
			{familyCase && familyJsx}
		</div>
	);
};

export default IndustryImageTextSection;
